package com.upcominds.expedite.data.auth

import kotlinx.browser.localStorage

class JsTokenStorage : TokenStorage {
    private val keyAccess = "access_token"
    private val keyRefresh = "refresh_token"
    private val keyId = "id_token"
    private val keyExpires = "expires_at_epoch_seconds"

    override fun save(tokens: TokenSet) {
        localStorage.setItem(keyAccess, tokens.accessToken)
        tokens.refreshToken?.let { localStorage.setItem(keyRefresh, it) } ?: localStorage.removeItem(keyRefresh)
        tokens.idToken?.let { localStorage.setItem(keyId, it) } ?: localStorage.removeItem(keyId)
        localStorage.setItem(keyExpires, tokens.expiresAtEpochSeconds.toString())
    }

    override fun load(): TokenSet? {
        val access = localStorage.getItem(keyAccess) ?: return null
        if (access.isEmpty()) return null

        val refresh = localStorage.getItem(keyRefresh)
        val id = localStorage.getItem(keyId)
        val exp = localStorage.getItem(keyExpires)?.toLongOrNull() ?: 0L

        return TokenSet(
            accessToken = access,
            refreshToken = refresh,
            idToken = id,
            expiresAtEpochSeconds = exp
        )
    }

    override fun clear() {
        localStorage.removeItem(keyAccess)
        localStorage.removeItem(keyRefresh)
        localStorage.removeItem(keyId)
        localStorage.removeItem(keyExpires)
    }
}
